"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAccessors = void 0;
const createGenericAccessor_1 = __importDefault(require("./createGenericAccessor"));
const createTAsync_1 = __importDefault(require("./createTAsync"));
/**
 * Create the concreted accessors collection from the i18next instance
 * @param t Specify the i18next instance
 * @returns The instance of the concreted accessors collection
 */
const createAccessors = (t) => {
    const { tCategoryStringedDetail, tDetail, tObj, tStringedDetail } = createGenericAccessor_1.default(t);
    const potentialsDetail = tDetail('potentials');
    return {
        brain: tDetail('brain'),
        communication: tDetail('communication'),
        genius: tDetail('genius'),
        getDescription: (type) => tObj('descriptions', { type }),
        lifeBase: tCategoryStringedDetail('lifeBase'),
        management: tDetail('management'),
        motivation: tStringedDetail('motivation'),
        position: tDetail('position'),
        potential: {
            getByKey: (p) => potentialsDetail.getByKey([...p].sort().join('.')),
            getCategoryDetail: potentialsDetail.getCategoryDetail,
        },
        response: tDetail('response'),
        vector: tDetail('vector'),
    };
};
exports.createAccessors = createAccessors;
/**
 * Create the concreted accessors collection asynchronously
 *
 * It is a synonym function that combines
 * `createAccessors()` and `createTAsync()`.
 * @param lng The language.
 *
 * If omitted, the language used is detected from the current environment.
 * @param additions The additional resources.
 * @returns The instance of the concreted accessors collection asynchronously
 * @see useLocale()
 */
exports.default = async (lng, additions) => {
    const t = await createTAsync_1.default({ lng, additions });
    return { ...exports.createAccessors(t), t };
};
//# sourceMappingURL=createAccessorsAsync.js.map